<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <small-delivery-plan :yacht="yacht" />
    <v-btn
      v-if="$can('set-logistics-plan', 'Yacht') && $route.name !== 'yachtDelivery'"
      class="text-capitalize"
      color="primary"
      rounded
      text
      block
      :to="{ name: $route.name.includes('service') ? 'serviceYachtDelivery' : 'yachtDelivery', params: { id: yacht.id }}"
    >
      <v-icon
        left
        small
      >
        format_list_numbered
      </v-icon>
      View Logistics
    </v-btn>
  </div>
</template>

<script>
import Yacht from '@/models/Yacht'
import SmallDeliveryPlan from './SmallDeliveryPlan'

export default {
    name: 'Delivery',
    components: { SmallDeliveryPlan },
    props: {
      yacht: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        yachtStatuses: Yacht
      }
    },
    computed: {
      canStartCharter() {
        return this.yacht.delivery_plan.steps.filter(s => !s.ended).length === 0
      }
    }
  }
</script>
